(function() {
    'use strict';

    let isLoading = false;
    let initialized = false;
    let lastFocusedElement = null; // Focus snapshot for restoration

    // ===============================
    // Accessible AJAX Filter System
    // ===============================

    function initAjaxFilters() { 
        if (initialized) return;

        //console.log('Initializing screen reader accessible AJAX filters...');

        // Store focus snapshot upon user interaction with filter elements
        document.addEventListener('focusin', function(e) {
            // Log for debugging (optional)
            /*if (e.target.closest('.facets, #FacetFiltersForm, .filter-sidebar, .t4s-filter')) {
                console.log('=== FOCUS DEBUG ===');
                console.log('Element:', e.target);
                console.log('Tag:', e.target.tagName);
                console.log('ID:', e.target.id);
                console.log('Classes:', e.target.className);
                console.log('Name:', e.target.name);
                console.log('Value:', e.target.value);
                console.log('Data attributes:', [...e.target.attributes].filter(attr => attr.name.startsWith('data-')));
                console.log('Parent element:', e.target.parentElement);
                console.log('==================');
            }*/
            if (e.target.matches('.facet-checkbox input, .facet-radio input, .facet-link, .t4s-active-filters a, #nin_collect_filter_price, [data-filter], .filter-option, .swatch-element, .pack-filter')) {
                storeFocusSnapshot(e.target);
               // console.log('✓ STORED focus element for restoration:', e.target.tagName, e.target.className);
            }
        });

        // Always refresh these listeners to avoid duplicate binding
        document.removeEventListener('click', handleFilterClick, true);
        document.addEventListener('click', handleFilterClick, true);
        document.removeEventListener('change', handleFormChange, true);
        document.addEventListener('change', handleFormChange, true);

        // Setup price filter
        const priceButton = document.querySelector('#nin_collect_filter_price');
        if (priceButton) {
            const newPriceButton = priceButton.cloneNode(true);
            priceButton.parentNode.replaceChild(newPriceButton, priceButton);
            newPriceButton.addEventListener('click', handlePriceFilter, true);
        }

        // Setup ARIA live regions for accessibility
        createLiveRegions();

        initialized = true;
        console.log('Screen reader accessible AJAX filters initialized');
    }

    function createLiveRegions() {
        // Status region for filter actions
        if (!document.getElementById('filter-status-region')) {
            const statusRegion = document.createElement('div');
            statusRegion.id = 'filter-status-region';
            statusRegion.setAttribute('aria-live', 'polite');
            statusRegion.setAttribute('aria-atomic', 'true');
            statusRegion.style.cssText = `
                position: absolute;
                left: -10000px;
                width: 1px;
                height: 1px;
                overflow: hidden;
            `;
            document.body.appendChild(statusRegion);
        }
        // Results region for product count
        if (!document.getElementById('filter-results-region')) {
            const resultsRegion = document.createElement('div');
            resultsRegion.id = 'filter-results-region';
            resultsRegion.setAttribute('aria-live', 'polite');
            resultsRegion.setAttribute('aria-atomic', 'false');
            resultsRegion.style.cssText = `
                position: absolute;
                left: -10000px;
                width: 1px;
                height: 1px;
                overflow: hidden;
            `;
            document.body.appendChild(resultsRegion);
        }
    }

    // ------------------------------
    // Focus Management Core
    // ------------------------------

    function storeFocusSnapshot(el) {
        if (!el) return;
        lastFocusedElement = {
            id: el.id || null,
            name: el.name || null,
            value: el.value || null,
            tagName: el.tagName || null,
            className: el.className || null,
            dataFilter: el.getAttribute?.('data-filter') || null,
            text: el.textContent?.trim() || null
        };
        //console.log('✓ STORED focus snapshot:', lastFocusedElement);
    }

    function restoreFocusForScreenReader() {
        //console.log('Restoring focus from snapshot:', lastFocusedElement);
        if (!lastFocusedElement) return focusOnFirstAvailableFilter();

        let targetElement = null;
        // 1. By ID
        if (lastFocusedElement.id) {
            targetElement = document.getElementById(lastFocusedElement.id);
        }
        // 2. By name + value (checkbox/radio)
        if (!targetElement && lastFocusedElement.name) {
            targetElement = document.querySelector(
                `[name="${lastFocusedElement.name}"][value="${lastFocusedElement.value}"]`
            );
        }
        // 3. By data-filter (swatch, pack filters)
        if (!targetElement && lastFocusedElement.dataFilter) {
            targetElement = document.querySelector(
                `[data-filter="${lastFocusedElement.dataFilter}"]`
            );
        }
        // 4. By tag + text (buttons, links)
        if (!targetElement && lastFocusedElement.tagName && lastFocusedElement.text) {
            const tag = lastFocusedElement.tagName.toLowerCase();
            targetElement = [...document.querySelectorAll(tag)]
                .find(el => el.textContent?.trim() === lastFocusedElement.text);
        }
        // 5. By class name (fallback)
        if (!targetElement && lastFocusedElement.className) {
            const classSelector = '.' + lastFocusedElement.className.split(' ').join('.');
            targetElement = document.querySelector(classSelector);
        }
        // ✅ Found: Set focus
        if (targetElement && document.body.contains(targetElement)) {
           // console.log('✓ Focus restored to:', targetElement);
            setTimeout(() => targetElement.focus(), 100);
            return;
        }
        // ❌ Fallback: first available filter
        //console.log('Focus restore failed, falling back...');
        focusOnFirstAvailableFilter();
    }

    function focusOnFirstAvailableFilter() {
        const selectors = [
            'input[type="checkbox"]:not([disabled])',
            'input[type="radio"]:not([disabled])',
            '.facet-checkbox input:not([disabled])',
            '.facet-radio input:not([disabled])',
            '.pack-filter:not([disabled])',
            '[data-filter]:not([disabled])',
            '.filter-option:not([disabled])',
            'button:not([disabled])'
        ];
        for (const selector of selectors) {
            const element = document.querySelector(selector);
            if (element && document.body.contains(element)) {
                //console.log('Focused on first available filter element:', selector);
                setTimeout(() => element.focus(), 100);
                return;
            }
        }
        // Fallback - focus on filter container
        const filterContainer = document.querySelector('.facets, #FacetFiltersForm, .filter-sidebar, .drawer-content');
        if (filterContainer) {
            if (!filterContainer.hasAttribute('tabindex')) {
                filterContainer.setAttribute('tabindex', '-1');
            }
            //console.log('Focused on filter container as final fallback');
            setTimeout(() => filterContainer.focus(), 100);
        }
    }

    // ------------------------------
    // Filter and Ajax Handlers
    // ------------------------------

    function handleFilterClick(e) {
        // For focus management and AJAX trigger
        const filterLink = e.target.closest('#FacetFiltersForm a, .t4s-active-filters a, .facet-checkbox, .facet-link, [data-filter], .filter-option, .swatch-element, .pack-filter, .filter-pack, .t4s-filter a, .t4s-facet a');
        if (filterLink && (filterLink.href || filterLink.hasAttribute('data-filter'))) {
            const focusedEl = e.target.matches('input, button, a, [data-filter], label') ? e.target
                                : e.target.closest('input, button, a, [data-filter], label');
            storeFocusSnapshot(focusedEl);

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (isLoading) {
                //console.log('Already loading, ignoring click');
                return false;
            }
           // console.log('Filter link clicked:', filterLink.href || filterLink.getAttribute('data-filter'));
            announceToScreenReader('Applying filter, please wait...');
            const url = filterLink.href || constructUrlFromDataFilter(filterLink);
            performAjaxFilter(url);
            return false;
        }
        // Fallback debug log
        if (e.target.closest('.facets, #FacetFiltersForm, .filter-sidebar, .t4s-filter')) {
           //console.log('⚠️ UNHANDLED CLICK in filter area:', e.target, 'Closest filter element:', e.target.closest('.facets, #FacetFiltersForm, .filter-sidebar, .t4s-filter'));
        }
    }
    function handleFormChange(e) {
        if (e.target.matches('.facet-checkbox input, .facet-radio input')) {
            storeFocusSnapshot(e.target);

            e.preventDefault();
            e.stopPropagation();
            if (isLoading) return false;
            //console.log('Form input changed');
            const filterLabel = e.target.closest('label')?.textContent?.trim() ||
                               e.target.getAttribute('aria-label') ||
                               'Filter option';
            const action = e.target.checked ? 'applied' : 'removed';
            announceToScreenReader(`${filterLabel} filter ${action}. Updating results...`);

            setTimeout(() => {
                const form = e.target.closest('form');
                if (form) {
                    const formData = new FormData(form);
                    const currentUrl = new URL(window.location.href);
                    const keysToRemove = [];
                    for (const [key] of currentUrl.searchParams) {
                        if (key.includes('filter') || key.includes('facet')) {
                            keysToRemove.push(key);
                        }
                    }
                    keysToRemove.forEach(key => currentUrl.searchParams.delete(key));
                    for (const [key, value] of formData) {
                        if (value && value.trim() !== '') {
                            currentUrl.searchParams.set(key, value);
                        }
                    }
                    performAjaxFilter(currentUrl.toString());
                }
            }, 100);
            return false;
        }
    }
    function handlePriceFilter(e) {
        storeFocusSnapshot(e.target); 
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isLoading) return false;
        announceToScreenReader('Applying price filter, please wait...');

        const minInput = document.querySelector('.t4s-min_price, input[name*="min"], input[name*="price.gte"]');
        const maxInput = document.querySelector('.t4s-max_price, input[name*="max"], input[name*="price.lte"]');
        const priceContainer = document.querySelector('.t4s-price_slider_amount, .price-filter');
//

//
        if (!minInput || !maxInput) {
            console.error('Price filter elements not found');
            return false;
        }

        const minParam = priceContainer?.dataset.minstr || 'filter.v.price.gte';
        const maxParam = priceContainer?.dataset.maxstr || 'filter.v.price.lte';

        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete(minParam);
        currentUrl.searchParams.delete(maxParam);

        const minPrice = minInput.value;
        const maxPrice = maxInput.value;

        if (!isNaN(minPrice) && minPrice >= 0) {
            currentUrl.searchParams.set(minParam, minPrice);
        }
        if (!isNaN(maxPrice) && maxPrice >= 0) {
            currentUrl.searchParams.set(maxParam, maxPrice);
        }
        performAjaxFilter(currentUrl.toString());
        return false;
    }
//


//
    function constructUrlFromDataFilter(element) {
        const dataFilter = element.getAttribute('data-filter');
        if (dataFilter) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('filter', dataFilter);
            return currentUrl.toString();
        }
        return window.location.href;
    }

    function performAjaxFilter(url) {
        //console.log('Performing AJAX request to:', url);

        isLoading = true;
        showLoading();

        const ajaxUrl = new URL(url);
        ajaxUrl.searchParams.set('ajax', '1');
        ajaxUrl.searchParams.set('timestamp', Date.now());

        fetch(ajaxUrl.toString(), {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'text/html',
                'Cache-Control': 'no-cache'
            }
        })
        .then(response => {
            //console.log('Response status:', response.status);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
        })
        .then(html => {
            //console.log('HTML response received, updating page...');
            updatePage(html, url);
        })
        .catch(error => {
            console.error('AJAX filter error:', error);
            hideLoading();
            isLoading = false;
            announceToScreenReader('Filter update failed. Please try again.');
            // Restore focus on error
            restoreFocusForScreenReader();
        });
    }

  function updatePage(html, url) {
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const selectorsToUpdate = {
        products: [
            '#gf-products',
            '.collection-products',
            '#product-grid',
            '[data-products]',
            '.products-grid',
            '.product-list',
            '.t4s-products',
            '#ProductGrid',
            '.grid-product',
            '.collection__products',
            '[data-collection-products]',
            '.product-grid-container',
            '.main-content .row',
            'main .products'
        ],
        filters: [
            '#t4s-filter-hidden',
            '.t4s-filter-hidden',
            '#FacetFiltersForm',
            '.facets',
            '[data-filters]',
            '.filter-sidebar',
            '.collection-sidebar'
        ],
        activeFilters: [
            '.t4s-active-filters',
            '.active-filters',
            '[data-active-filters]',
            '.facets-active',
            '.applied-filters'
        ],
        counts: [
            '.collection-product-count',
            '.results-count',
            '[data-results-count]',
            '.product-count'
        ]
    };

    let productGridUpdated = false;
    let newProductCount = 0;

    // ===============================
    // 1. Try [data-ntajax-container]
    // ===============================
    const currentAjaxContainer = document.querySelector('[data-ntajax-container]');
    const newAjaxContainer = newDoc.querySelector('[data-ntajax-container]');

    if (currentAjaxContainer && newAjaxContainer) {
        currentAjaxContainer.style.transition = 'opacity 0.2s ease';
        currentAjaxContainer.style.opacity = '0.5';
        setTimeout(() => {
            currentAjaxContainer.innerHTML = newAjaxContainer.innerHTML;
            currentAjaxContainer.style.opacity = '1';
            newProductCount = currentAjaxContainer.querySelectorAll(
                '[data-product], .product-item, .grid-product__content, .product-card'
            ).length;
        }, 100);
        productGridUpdated = true;
    } else {
        // ===============================
        // 2. Fallback: your selectors
        // ===============================
        for (let selector of selectorsToUpdate.products) {
            const currentEl = document.querySelector(selector);
            const newEl = newDoc.querySelector(selector);
            if (currentEl && newEl) {
                currentEl.style.transition = 'opacity 0.2s ease';
                currentEl.style.opacity = '0.5';
                setTimeout(() => {
                    currentEl.innerHTML = newEl.innerHTML;
                    currentEl.style.opacity = '1';
                    newProductCount = currentEl.querySelectorAll(
                        '[data-product], .product-item, .grid-product__content, .product-card'
                    ).length;
                }, 100);
                productGridUpdated = true;
                break;
            }
        }
    }

    // Filters
    selectorsToUpdate.filters.forEach(selector => {
        const currentEl = document.querySelector(selector);
        const newEl = newDoc.querySelector(selector);
        if (currentEl && newEl) currentEl.innerHTML = newEl.innerHTML;
    });

    // Active filters
    selectorsToUpdate.activeFilters.forEach(selector => {
        const currentEl = document.querySelector(selector);
        const newEl = newDoc.querySelector(selector);
        if (currentEl) {
            if (newEl && newEl.innerHTML.trim()) {
                currentEl.innerHTML = newEl.innerHTML;
                currentEl.style.display = '';
            } else {
                currentEl.style.display = 'none';
            }
        }
    });

    // Counts
    selectorsToUpdate.counts.forEach(selector => {
        const currentEl = document.querySelector(selector);
        const newEl = newDoc.querySelector(selector);
        if (currentEl && newEl) currentEl.innerHTML = newEl.innerHTML;
    });

    // Title
    const newTitle = newDoc.querySelector('title');
    if (newTitle) document.title = newTitle.textContent;

    // URL
    if (url !== window.location.href) {
        window.history.pushState(
            { path: url, timestamp: Date.now(), isAjaxFilter: true },
            '',
            url
        );
    }

    hideLoading();
    isLoading = false;

    // Accessibility + re-init
    setTimeout(() => {
        if (productGridUpdated) {
            const countText =
                newProductCount === 1
                    ? '1 product found'
                    : `${newProductCount} products found`;
            announceResults(countText);
        }
        restoreFocusForScreenReader();

        initialized = false;
        setTimeout(() => {
            initAjaxFilters();
            window.dispatchEvent(
                new CustomEvent('ajaxFiltersUpdated', {
                    detail: { url: url, productCount: newProductCount }
                })
            );
            document.dispatchEvent(new CustomEvent('filters:updated'));
        }, 50);
    }, 250);
}


    function announceToScreenReader(message) {
        const statusRegion = document.getElementById('filter-status-region');
        if (statusRegion) {
            statusRegion.textContent = '';
            setTimeout(() => {
                statusRegion.textContent = message;
                //console.log('Screen reader announcement:', message);
            }, 50);
        }
    }

    function announceResults(message) {
        const resultsRegion = document.getElementById('filter-results-region');
        if (resultsRegion) {
            setTimeout(() => {
                resultsRegion.textContent = message;
               // console.log('Results announcement:', message);
            }, 200);
        }
    }

    function showLoading() {
        let loadingDiv = document.getElementById('ajax-filter-loading');
        if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.id = 'ajax-filter-loading';
            loadingDiv.setAttribute('role', 'status');
            loadingDiv.setAttribute('aria-live', 'polite');
            loadingDiv.setAttribute('aria-label', 'Filtering products, please wait');
            loadingDiv.style.cssText = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 99999;
            `;
            loadingDiv.innerHTML = `
                <div style="
                    background: #333;
                    color: #fff;
                    padding: 20px 30px;
                    border-radius: 6px;
                    font-size: 16px;
                    font-weight: 500;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                "><span>Filtering...</span>
                <div style="
                    width: 18px;
                    height: 18px;
                    border: 2px solid rgba(255,255,255,0.3);
                    border-top: 2px solid #fff;
                    border-radius: 50%;
                    animation: filterSpin 0.8s linear infinite;
                "></div></div>`;
            if (!document.getElementById('filter-spinner-style')) {
                const style = document.createElement('style');
                style.id = 'filter-spinner-style';
                style.textContent = `
                    @keyframes filterSpin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `;
                document.head.appendChild(style);
            }
            document.body.appendChild(loadingDiv);
        } else {
            loadingDiv.style.display = 'flex';
        }
    }
    function hideLoading() {
        const loadingDiv = document.getElementById('ajax-filter-loading');
        if (loadingDiv) {
            loadingDiv.style.display = 'none';
        }
    }

    // Prevent default submit for filter forms
    document.addEventListener('submit', function(e) {
        const form = e.target;
        if (form.querySelector('[name*="filter"], .facet-checkbox, .facet-radio') ||
            form.id === 'FacetFiltersForm' ||
            form.classList.contains('facets') ||
            form.classList.contains('filter-form')) {
            //console.log('Preventing form submission - using AJAX instead');
            e.preventDefault();
            return false;
        }
    });

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAjaxFilters);
    } else {
        initAjaxFilters();
    }

    // Browser navigation restoration
    window.addEventListener('popstate', function(event) {
        if (event.state && event.state.isAjaxFilter) {
            //console.log('Browser back/forward detected - reloading for sync');
            location.reload();
        }
    });

    // Global AJAX filter utility
    window.ajaxFilter = function(url) {
        if (!isLoading) {
            performAjaxFilter(url);
        }
    };

    // Listen for external events to restore focus (for SPA frameworks, section reloads, etc)
    document.addEventListener('filters:updated', () => {
        restoreFocusForScreenReader();
        
    });
    document.addEventListener('shopify:section:load', () => {
        restoreFocusForScreenReader();
        
    });

   // console.log('Screen reader accessible AJAX Filter system loaded and ready');
})();
